import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { TrackerApi } from '@telecom/shared/infrastructure/api-functions/tracker-api';
import { TrackerApiImpl } from '@telecom/shared/infrastructure/api-functions/impls/tracker-api-impl';
import { RavenService } from '@telecom/shared/services/raven-service/raven-service';
import { RavenServiceImpl } from '@telecom/shared/services/raven-service/impls/raven-service';

export const trackerModule = new ContainerModule((bind) => {
    bind(TrackerApi).to(TrackerApiImpl);
    bind(RavenService).to(RavenServiceImpl);
});
